import { useTranslation } from 'react-i18next';

export type MatchCountProps = {
  selfReferralCount?: number,
  count: number,
  max: number,
}

function MatchCount({
  selfReferralCount,
  count,
  max,
}: MatchCountProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="text-end">
      {selfReferralCount !== undefined && selfReferralCount > 0 && (
        <span>{`${selfReferralCount} ${t('Self_Referrals')}`}</span>
      )}
      {selfReferralCount !== undefined && selfReferralCount > 0 && count > 0}
      <span className={count >= max ? 'text-danger' : ''}>
        &nbsp; &nbsp;
        {`${count} / ${max} ${t('Matches')}`}
      </span>
    </div>
  );
}

MatchCount.defaultProps = {
  selfReferralCount: undefined,
};

export default MatchCount;
